import { useState } from 'react';
import { api, ApiError } from '../../api/client.js';
import { FormField } from '../FormField.jsx';
import { PasswordInput } from '../PasswordInput.jsx';
import { SubmitButton } from '../SubmitButton.jsx';

export function SecuritySection() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [globalError, setGlobalError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFieldErrors({});
    setGlobalError(null);
    setSuccess(false);

    if (next !== confirm) {
      setFieldErrors({ confirm: 'passwords do not match' });
      return;
    }

    setSaving(true);
    try {
      await api.changePassword({ current_password: current, new_password: next });
      setCurrent('');
      setNext('');
      setConfirm('');
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      if (err instanceof ApiError && err.fieldErrors) {
        setFieldErrors(err.fieldErrors);
      } else {
        setGlobalError(err);
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <section className="settings-section">
        <h2>Change password</h2>
        <p className="settings-section-hint">Use at least 12 characters, including a letter and a digit.</p>

        <form onSubmit={handleSubmit} className="settings-form" noValidate>
          <FormField
            label="Current password"
            htmlFor="security-current"
            error={fieldErrors.current_password}
          >
            <PasswordInput
              id="security-current"
              name="current_password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              error={Boolean(fieldErrors.current_password)}
              autoComplete="current-password"
              required
            />
          </FormField>

          <FormField
            label="New password"
            htmlFor="security-new"
            error={fieldErrors.new_password}
            hint="At least 12 characters, with a letter and a digit."
          >
            <PasswordInput
              id="security-new"
              name="new_password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              error={Boolean(fieldErrors.new_password)}
              autoComplete="new-password"
              minLength={12}
              required
            />
          </FormField>

          <FormField
            label="Confirm new password"
            htmlFor="security-confirm"
            error={fieldErrors.confirm}
          >
            <PasswordInput
              id="security-confirm"
              name="confirm_password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              error={Boolean(fieldErrors.confirm)}
              autoComplete="new-password"
              required
            />
          </FormField>

          <div className="settings-form-actions">
            <SubmitButton
              loading={saving}
              disabled={!current || !next || !confirm}
            >
              Change password
            </SubmitButton>
            {success && (
              <span className="invite-success" role="status">Password updated.</span>
            )}
            {globalError && (
              <span className="invite-error" role="alert">
                {globalError instanceof ApiError ? (globalError.message || 'Couldn\u2019t change password.') : 'Couldn\u2019t change password.'}
              </span>
            )}
          </div>
        </form>
      </section>

      <section className="settings-section">
        <h2>Sessions</h2>
        <p className="settings-section-hint">Active session management is coming soon.</p>
      </section>
    </>
  );
}
